import React, {Component} from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <span className="ml-auto">
          <a 
            href="http://honeycomb.ai"
            target="_blank"
          >Honeycomb.ai Solutions Inc.
          </a>
        </span>
      </footer>
    )
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js